export const canEditEmailPagBank = (isPagBank?: boolean | null): boolean => {
  if (!isPagBank) return false;

  const user = JSON.parse(localStorage.getItem('auth-user') || 'null');

  return !!user?.permissions?.some(
    (permission: { role_id?: string; status?: boolean }) =>
      permission.role_id === 'DASH_USER_EDIT_EMAIL_PAGBANK' && !!permission.status,
  );
};
